import React, { useContext } from 'react';
import views, { imprint, privacy } from 'views';
import { Link } from 'react-router-dom';
import { RouteContext } from 'containers/Page.context';
import clsx from 'clsx';

/**
 * This component is the footer container.
 * It contains the page navigation and manages it with the help of the {@link RouteContext}.
 */
const Footer = () => {
  const { index } = useContext(RouteContext);

  return (
    <footer
      data-testid="footer"
      className={clsx(
        'footer flex w-full h-1/12 items-center justify-center text-sm lg:text-base',
      )}
    >
      <div
        data-testid="footer-hash"
        className="footer-hash text-gray flex w-full flex-wrap justify-center"
      >
        <div className="mx-3">#Eberswalde</div>
        <div className="mx-3">#FahrschuleUnternBuchen</div>
        <div className="mx-3">#AndréZieroth</div>
        <Link
          className={clsx(
            'footer-impressum text-gray mx-3',
            views[index].theme === 'dark' && 'hover:text-red',
            views[index].theme === 'light' && 'hover:text-white',
          )}
          to={imprint.pathname}
        >
          @{imprint.name}
        </Link>
        <Link
          className={clsx(
            'footer-datenschutz ml-3 text-gray',
            views[index].theme === 'dark' && 'hover:text-red',
            views[index].theme === 'light' && 'hover:text-white',
          )}
          to={privacy.pathname}
        >
          @{privacy.name}
        </Link>
      </div>
    </footer>
  );
};

export default Footer;
